export default {
  scrollPosition: state => state.scrollPosition,
  screenSize: state => state.screen,
  screenType: state => state.isMobile
}
